import { Link } from "react-router-dom";
import { Phone, Mail, MessageCircle, Linkedin, MapPin, ArrowRight } from "lucide-react";
import { BRAND } from "@/lib/site";

export default function ContactPage() {
  return (
    <div data-testid="contact-page" className="container-x py-16 md:py-24">
      <div className="grid md:grid-cols-12 gap-10">
        <div className="md:col-span-6">
          <span className="eyebrow">Contact</span>
          <h1 className="mt-4 h-display text-4xl sm:text-5xl lg:text-6xl">
            Talk to Raj —<br />Your partner in growth.
          </h1>
          <p className="mt-6 text-brand-sage text-lg leading-relaxed max-w-md">
            Whether it's a 5-minute question or a full project finance brief —
            we'd love to hear from you.
          </p>

          <div className="mt-10 space-y-3">
            <ContactRow
              testid="contact-phone"
              href={`tel:${BRAND.phoneE164}`}
              icon={<Phone className="h-5 w-5" />}
              label="Call"
              value={BRAND.phone}
            />
            <ContactRow
              testid="contact-whatsapp"
              href={`https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent("Hi Raj, I'd like to discuss a loan.")}`}
              external
              icon={<MessageCircle className="h-5 w-5" />}
              label="WhatsApp"
              value={`+91 ${BRAND.phone}`}
            />
            <ContactRow
              testid="contact-email"
              href={`mailto:${BRAND.email}`}
              icon={<Mail className="h-5 w-5" />}
              label="Email"
              value={BRAND.email}
            />
            <ContactRow
              testid="contact-linkedin"
              href={BRAND.linkedin}
              external
              icon={<Linkedin className="h-5 w-5" />}
              label="LinkedIn"
              value="Rajasekhar Kasunur"
            />
            <ContactRow
              testid="contact-location"
              icon={<MapPin className="h-5 w-5" />}
              label="Based in"
              value={`${BRAND.city}, Karnataka`}
            />
          </div>
        </div>

        <aside className="md:col-span-6">
          <div className="card-soft p-8 md:p-10">
            <h3 className="font-outfit font-bold text-2xl text-brand-forest">
              Prefer the structured route?
            </h3>
            <p className="mt-3 text-brand-sage leading-relaxed">
              Submit a quick loan inquiry and Raj will personally reach out with
              a shortlist of best-fit lenders within one business day.
            </p>
            <Link to="/apply" data-testid="contact-apply-btn" className="btn-primary mt-7">
              Start a Loan Inquiry <ArrowRight className="h-4 w-4" />
            </Link>

            <div className="mt-10 pt-8 border-t border-brand-sand">
              <div className="text-xs uppercase tracking-[0.18em] text-brand-terracotta font-semibold">
                Network
              </div>
              <p className="mt-3 text-brand-forest font-outfit font-semibold text-lg">
                15+ lender partners across banks &amp; NBFCs
              </p>
              <p className="mt-2 text-sm text-brand-sage">
                Referral-led, reputation-driven loan facilitation since {BRAND.founded}.
              </p>
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
}

function ContactRow({ icon, label, value, href, external, testid }) {
  const Wrap = href ? "a" : "div";
  const props = href
    ? { href, ...(external ? { target: "_blank", rel: "noreferrer" } : {}) }
    : {};
  return (
    <Wrap
      {...props}
      data-testid={testid}
      className="flex items-center gap-4 rounded-2xl border border-brand-sand bg-white px-5 py-4 transition-all hover:border-brand-terracotta/40 hover:-translate-y-0.5"
    >
      <span className="grid h-11 w-11 place-items-center rounded-xl bg-brand-forest text-brand-gold">
        {icon}
      </span>
      <div>
        <div className="text-xs uppercase tracking-[0.16em] text-brand-sage">{label}</div>
        <div className="font-outfit font-semibold text-brand-forest">{value}</div>
      </div>
    </Wrap>
  );
}
